import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { cardEmits, cardProps } from './card';
import { UPDATE_MODEL_VALUE } from '../../constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'card',
  props: cardProps,
  emits: cardEmits,
  setup(__props, { expose, emit: emits }) {

const props = __props




const isEdit = ref<boolean>(props.modelValue ?? false);

const handleClickReset = (): void => {
    isEdit.value = false;
    emits('reset', isEdit.value);
    emits(UPDATE_MODEL_VALUE, isEdit.value);
};

const handleClickSave = (): void => {
    isEdit.value = false;
    emits('save', isEdit.value);
    emits(UPDATE_MODEL_VALUE, isEdit.value);
};

const handleClickEdit = (): void => {
    isEdit.value = true;
    emits('edit', isEdit.value);
    emits(UPDATE_MODEL_VALUE, isEdit.value);
};

expose({
    isEdit,
});

return { __sfc: true,props, emits, isEdit, handleClickReset, handleClickSave, handleClickEdit }
}

})